import { useState, useEffect, RefObject } from "react";

interface Size {
  width: number;
  height: number;
}

const useElementSize = (elementRef: RefObject<HTMLElement>): Size => {
  const [elementSize, setElementSize] = useState<Size>({
    width: 0,
    height: 0,
  });

  useEffect(() => {
    const element = elementRef.current;
    if (element) {
      const resizeObserver = new ResizeObserver((entries) => {
        const { width, height } = entries[0].contentRect;
        setElementSize({ width, height });
      });
      resizeObserver.observe(element);
      return () => {
        resizeObserver.unobserve(element);
        resizeObserver.disconnect();
      };
    }
  }, [elementRef]);

  return elementSize;
}

export default useElementSize;